import Axios from "axios"

const modules = {
}

const state = {
	loggedIn: false,
	accessToken: '',
	expires: '',
	loading: false,
	refreshToken: '',
}

const getters = {
	isLoggedIn: (state) => {
		return state.loggedIn
	}
}

const mutations = {
	startLoading: (state) => {
		state.loading = true
	},
	stopLoading: (state) => {
		state.loading = false
	},
	storeCredentials: (state, payload) => {
		state.loggedIn = true
		state.accessToken = payload.access_token
		state.refreshToken = payload.refresh_token
		state.expires = payload.expires_in
	},
	clearCredentials: (state) => {
		state.loggedIn = false
		state.accessToken = ''
		state.refreshToken = ''
		state.expires = ''
	},
}

const actions = {
	login: ({ commit, dispatch }, payload) => {
		commit('startLoading')
		Axios.post('https://data.character.gallery/oauth/token', payload)
		.then(function(response){
			/*eslint-disable-next-line no-console*/
			console.log('response:', response)
			commit('storeCredentials',response.data)
			commit('modals/hideLogin', null, {root: true})
			Axios.defaults.headers.common['Authorization'] = 'Bearer '+response.data.access_token
		})
		.catch(function(error){
			/*eslint-disable-next-line no-console*/
			console.log('error:', error.toJSON())
			if(error.response){
				/*eslint-disable-next-line no-console*/
				console.log('error:', error.response)
				var message = ''
				switch(error.response.status){
					case 401:
						message = 'Email or password were incorrect. Please try again.'
						break;
					default:
						message = 'Something went wrong. Try again later.'
				}
				dispatch('modals/setError',{
					message,module:'account'
				},{root:true})
			}else{
				dispatch('modals/setError',{
					message:error.message,
					module:'account'
				},{root:true})
			}
			
		})
		.finally(function(){
			commit('stopLoading')
		})
	},
	logout: ({ commit }) => {
		commit('clearCredentials')
	}

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
	modules,
}